<template>
    <flex-container direction="column" align="center" class="order-discount">
        <p class="order-discount__title mb-10" :class="{ 'ended-discount': discountEnded }">
            {{ !discountEnded ? t("payments.discount_offer_is_present") : t("payments.discount_offer_ended") }}
        </p>

        <flex-container
            v-if="!discountEnded && this.untilDate"
            direction="column"
            align="center"
            class="order-discount__timer-container"
        >
            <p class="order-discount__timer-title">{{ t("payments.price_is_valid") }}</p>
            <p class="order-discount__timer">
                <span>
                    <span class="counter">{{ days }}</span> {{ t("payments.days") }}
                </span>
                <span>
                    <span class="counter">{{ hours }}</span> {{ t("payments.hours") }}
                </span>
                <span>
                    <span class="counter">{{ minutes }}</span> {{ t("payments.minutes") }}
                </span>
                <span>
                    <span class="counter">{{ seconds }}</span> {{ t("payments.seconds") }}
                </span>
            </p>
        </flex-container>
    </flex-container>
</template>

<script>
import FlexContainer from "@components/Containers/FlexContainer"
import formatDate from "@mixins/formatDate"

export default {
    name: "PublicOfferOrderDiscount",
    components: {
        FlexContainer
    },
    mixins: [formatDate],
    props: {
        untilDate: {
            type: String,
            required: true
        }
    },
    data: () => ({
        days: null,
        hours: null,
        minutes: null,
        seconds: null,
        timerInterval: 0,
        nowTimestamp: null,
        untilTimestamp: null,
        discountEnded: false
    }),
    created() {
        this.createTimer()
    },
    methods: {
        createTimer() {
            const dateNow = new Date()
            this.nowTimestamp = this.toTimestamp(dateNow)

            if (!this.untilDate) {
                return
            }

            this.untilTimestamp = this.toTimestamp(this.untilDate)

            // Stop timer with wrong conditions
            if (this.nowTimestamp === this.untilTimestamp || this.nowTimestamp > this.untilTimestamp) {
                return this.stopTimer()
            }
            // Init timer data
            this.countTime(this.nowTimestamp)
            // Start count interval
            this.timerInterval = setInterval(() => {
                this.nowTimestamp += 1
                this.countTime(this.nowTimestamp)
                // Stop timer with wrong conditions
                if (this.nowTimestamp === this.untilTimestamp || this.nowTimestamp > this.untilTimestamp) {
                    clearInterval(this.timerInterval)
                    this.stopTimer()
                }
            }, 1000)
        },
        countTime(now) {
            let delta = Math.abs(this.untilTimestamp - now)
            this.days = Math.floor(delta / 86400)
            delta -= this.days * 86400

            this.hours = Math.floor(delta / 3600) % 24
            delta -= this.hours * 3600

            this.minutes = Math.floor(delta / 60) % 60
            delta -= this.minutes * 60

            this.seconds = delta % 60
        },
        stopTimer() {
            this.discountEnded = true
        }
    }
}
</script>

<style scoped lang="sass">
@import 'resources/sass/vars'

.ended-discount
    color: $danger-color

.order-discount
    padding: 20px
    background: $bgc11
    border-radius: 8px
    &__title
        font-size: 18px
        line-height: 130%
        font-weight: 600
    &__timer-container
        font-size: 14px
        line-height: 130%
        font-weight: 400
        color: $text-accent-color
        .counter
            color: $accent-color5
</style>
